import type {ReactNode,PointerEvent} from 'react';
import {PanelLeft} from 'lucide-react';
import {ContextLabLibrary} from './ContextLabLibrary';
import {ContextLabScene,type ContextLabSceneProps} from './ContextLabScene';
import type {LabCatalog,LabSelection} from './mini-lab-catalog';
import './measurement-context.css';
import './context-library.css';

/** Shared presentation shell. The host activity owns configuration, state and actions. */
export function MiniLabWorkspace({catalog,libraryOpen,onToggleLibrary,onSelect,onEntryPointerDown,scene,captions,children,guidance}:{catalog:LabCatalog;libraryOpen:boolean;onToggleLibrary:()=>void;onSelect:(selection:LabSelection)=>void;onEntryPointerDown?:(selection:LabSelection,event:PointerEvent<HTMLButtonElement>)=>void;scene:ContextLabSceneProps;captions:ReactNode;children?:ReactNode;guidance?:ReactNode}){
 return <div className={'with-library context-lab-layout manipulation-workspace'+(libraryOpen?'':' library-is-collapsed')}>
  <ContextLabLibrary catalog={catalog} open={libraryOpen} onToggle={onToggleLibrary} onSelect={onSelect} onEntryPointerDown={onEntryPointerDown}/>
  <div className="context-main">
   <section className="context-workspace" aria-label="Manipulation sur la paillasse">
    <div className="context-toolbar"><button className="library-toggle" aria-label={libraryOpen?'Replier la bibliothèque':'Ouvrir la bibliothèque'} aria-expanded={libraryOpen} aria-controls="context-library" onClick={onToggleLibrary}><PanelLeft size={17}/><span>Bibliothèque</span></button><div className="context-bench-title"><span>PAILLASSE</span><strong>Votre expérience</strong></div><span className="context-bench-mode"><i/>{catalog.activityLabel}</span></div>
    <div className="context-scene-wrap" data-context-trigger><ContextLabScene {...scene}/></div>
    <div className="mini-lab-inventory" aria-label="Matériel installé">{captions}</div>
    {children}
   </section>
   {guidance}
  </div>
 </div>;
}
